const SvgGraduationHatIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <path
        d="M14.166 12.0833V9.57866C14.166 9.4291 14.166 9.35431 14.1432 9.28829C14.1231 9.22991 14.0902 9.17673 14.047 9.1326C13.9982 9.08271 13.9313 9.04927 13.7975 8.98238L9.99935 7.08331M3.33268 7.91664V13.5888C3.33268 13.8987 3.33268 14.0537 3.38103 14.1894C3.42377 14.3093 3.49343 14.4179 3.58466 14.5067C3.68786 14.6072 3.82874 14.6718 4.11048 14.8009L9.44381 17.2454C9.64817 17.339 9.75035 17.3859 9.8568 17.4043C9.95113 17.4207 10.0476 17.4207 10.1419 17.4043C10.2483 17.3859 10.3505 17.339 10.5549 17.2454L15.8882 14.8009C16.17 14.6718 16.3108 14.6072 16.414 14.5067C16.5053 14.4179 16.5749 14.3093 16.6177 14.1894C16.666 14.0537 16.666 13.8987 16.666 13.5888V7.91664M1.66602 7.08331L9.70121 3.06571C9.81053 3.01105 9.86518 2.98372 9.92252 2.97297C9.9733 2.96344 10.0254 2.96344 10.0762 2.97297C10.1335 2.98372 10.1882 3.01105 10.2975 3.06571L18.3327 7.08331L10.2975 11.1009C10.1882 11.1556 10.1335 11.1829 10.0762 11.1936C10.0254 11.2032 9.9733 11.2032 9.92252 11.1936C9.86518 11.1829 9.81053 11.1556 9.70121 11.1009L1.66602 7.08331Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgGraduationHatIcon
